import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold text-green-400">VitaBridge</h3>
            <p className="mt-2 text-gray-400 text-sm">Empowering rural households for a sustainable future.</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-200">Quick Links</h3>
            <ul className="mt-2 space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white text-sm">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm">Contact</Link></li>
              <li><Link to="/hubs" className="text-gray-400 hover:text-white text-sm">Find a Hub</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-200">Connect</h3>
            <p className="mt-2 text-gray-400 text-sm">info@VitaBridge.org</p>
            <p className="text-gray-400 text-sm">+91 12345 67890</p>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-4 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} VitaBridge. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}


